var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBattery = function SvgBattery(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "icon_1_",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3009",
    transform: "translate(.062 -.84)scale(1.9961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "figure"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 4.094H.969a1 1 0 0 0-1 1v7.813c0 .553 1.292 2 1.844 2h12.406c.553 0 1.781-1.447 1.781-2V5.094a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon11",
    fill: "#f1f1f1",
    fillRule: "evenodd",
    d: "M4 9.313V8.004h1.387V6.965H4V5.688H3v1.277H1.672v1.039H3v1.309z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "minus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect16",
    fill: "#f1f1f1",
    fillRule: "evenodd",
    d: "M11.016 6.965h2.996v1.039h-2.996z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect21",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.016 1.965h2.996v1.352h-2.996z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect26",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.016 1.965h2.996v1.352H2.016z",
    clipRule: "evenodd"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBattery);
export default ForwardRef;